import Api from "./HandleErrorApi";

class DemoApi {
    api = new Api();

    async createDemoBid(data)
    {
        return this.api.post('demo/createDemoBid', data);
    }
}

export default new DemoApi();
